var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "14-Invoices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.07---Invoices---Error",
    transform: "translate(-830.000000, -471.000000)",
    fill: "#5DB85C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(586.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(244.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6929356,3.7945531 L15.2013651,2.30636746 C14.9967453,2.10207772 14.7479707,2 14.4555798,2 C14.1630543,2 13.9142797,2.10207772 13.7096599,2.30636746 L6.51485151,9.49586213 L3.29033993,6.26765438 C3.08558553,6.06336464 2.83694557,5.96128692 2.54455467,5.96128692 C2.25202916,5.96128692 2.0033892,6.06336464 1.7986348,6.26765438 L0.30706429,7.75584002 C0.10230989,7.96012977 0,8.20820548 0,8.50006716 C0,8.79179452 0.10230989,9.04000455 0.30706429,9.24415998 L4.27736113,13.2054469 L5.76906626,14.6936325 C5.97368604,14.8979223 6.222326,15 6.51485151,15 C6.80724241,15 7.05588237,14.897788 7.26063677,14.6936325 L8.75234189,13.2054469 L16.6929356,5.28287305 C16.8975554,5.07858331 16.9999999,4.8305076 16.9999999,4.53864592 C17.0001345,4.24691855 16.8975554,3.99884284 16.6929356,3.7945531 L16.6929356,3.7945531 Z",
    id: "Shape-Copy"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/Green_Checkmark.fba34947156a74b5f4ec4837900d946b.svg";
export { ForwardRef as ReactComponent };